import { createSlice } from "@reduxjs/toolkit";

export interface LoginState {
	uid: number|null,
	auth_token: string|null,
	email_verified_at: string|null,
	checkin: boolean,
	isLoading: boolean,
	isError: boolean,
	errorCode: number,
	errorMessage: string|null,
}

export const initialState: LoginState = {
	uid: null,
	auth_token: localStorage.getItem('auth_token'),
	email_verified_at: null,
	checkin: true,
	isLoading: false,
	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const AuthSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		onRegister: (state, action) => {
			return { ...state, ...action.payload, isLoading: true };
		},

		onConfirm: (state, action) => {
			return { ...state, ...action.payload, isLoading: true };
		},

		onSuccessLogin: (state, action) => {
			if( action.payload.data.auth_token && action.payload.data.email_verified_at ) {
				localStorage.setItem('auth_token', action.payload.data.auth_token);
			}

			return {
				...state,
				...action.payload.data,
			};
		},

		onLogin: (state, action) => {
			return { ...state, ...action.payload, isLoading: true };
		},

		onRecovery: (state, action) => {
			return { ...state, ...action.payload, isLoading: true };
		},

		onReset: (state, action) => {
			return { ...state, ...action.payload, isLoading: true };
		},

		onSuccessLogout: (state, action) => {
			localStorage.removeItem('auth_token');
			window.location.href = '/';
			return { ...state, ...action.payload, isLoading: false };
		},

		onLogout: (state, action) => {
			//
			return { ...state, ...action.payload, isLoading: false };
		},


		clearError: (state, action) => {
			return { ...state, isError: false, errorCode: 0, errorMessage: null };
		},
	},
});

export const {
	onRegister,
	onConfirm,
	onLogin,
	onRecovery,
	onReset,
	onLogout,
	clearError,
} = AuthSlice.actions;
